import { formatDateTimeWithTimeZone, parseDate } from '@ais-ui/utils';
import { QueryPointResult } from '@ais-ui/websockets';

export interface WeatherReport {
  airPressure: string;
  airPressureSensorDataDesc: string;
  airPressureTrend: string;
  airTemperature: string;
  airTemperatureSensorDataDesc: string;
  dewPoint: string;
  dewPointSensorDataDesc: string;
  salinity: string;
  weatherTimestamp: Date | null;
}

const desiredReportKeys: string[] = [
  'air_pressure',
  'air_pressure_sensor_data_desc',
  'air_pressure_trend',
  'air_temperature',
  'air_temperature_sensor_data_desc',
  'dew_point',
  'dew_point_sensor_data_desc',
  'salinity',
  'timestamp',
];

export function extractEnvironmentalWeatherReport(
  result: QueryPointResult
): WeatherReport {
  const rawWeatherReportInfo: { [key: string]: any } = {};
  for (const target of result.targetInfo) {
    const weatherReport = target?.values_json['weather_report'];
    if (weatherReport) {
      for (const [report_key, report_value] of Object.entries(weatherReport)) {
        if (desiredReportKeys.includes(report_key)) {
          rawWeatherReportInfo[report_key] = report_value;
        }
      }
    }
  }
  return {
    airPressure: rawWeatherReportInfo['air_pressure'],
    airPressureSensorDataDesc:
      rawWeatherReportInfo['air_pressure_sensor_data_desc'],
    airPressureTrend: rawWeatherReportInfo['air_pressure_trend'],
    airTemperature: rawWeatherReportInfo['air_temperature'],
    airTemperatureSensorDataDesc:
      rawWeatherReportInfo['air_temperature_sensor_data_desc'],
    dewPoint: rawWeatherReportInfo['dew_point'],
    dewPointSensorDataDesc: rawWeatherReportInfo['dew_point_sensor_data_desc'],
    salinity: rawWeatherReportInfo['salinity'],
    weatherTimestamp: rawWeatherReportInfo['timestamp']
      ? parseDate(rawWeatherReportInfo['timestamp'])
      : null,
  };
}
